import axios from 'axios';

const axiosClient = axios.create({
  baseURL: window.fromServer.env.API_URL,
  xsrfHeaderName: 'x-csrftoken',
  withCredentials: true,
});

export default axiosClient;
